<template>
    <div>
        <div class="modal-small-toolbar">
            <span>User Settings</span>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        data() {
            return {
                loading: false,
                errors: ''
            }
        },

        computed: {
        	...mapState(['users'])
        },

        methods: {

        }
    }
</script>